module.exports = __webpack_public_path__ + "img/douyin-avatars.b1f53cd6.png";